import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=5c59f4c6"
import script from "./videoList.vue?vue&type=script&lang=js"
export * from "./videoList.vue?vue&type=script&lang=js"
import style1 from "./videoList.vue?vue&type=style&index=1&id=5c59f4c6&prod&lang=scss"
import style2 from "./videoList.vue?vue&type=style&index=2&id=5c59f4c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports